module.exports = __webpack_public_path__ + "img/bk.036e1555.jpg";